import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-logged-in-card',
  templateUrl: './logged-in-card.component.html',
  styleUrls: ['./logged-in-card.component.scss'],
  // encapsulation: ViewEncapsulation.None  
})
export class LoggedInCardComponent implements OnInit {

  @Input() userVerifiedBin: string;
  @Output() openLoginModal = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  openLogin() {
    this.openLoginModal.emit();
  }

}
